import AnnouncementsViewPage from './announcementsViewPage';

export default AnnouncementsViewPage;
